{
  "brand_name": "Tiago de Paula BJJ",
  "announcement": "New schedule from 17 August: 45+ weekly classes in Zurich & Thalwil",
  "announcement_link": "#news",
  "member_portal": "mailto:contact@tiagodepaulabjj.com",
  "instagram_profile": "https://www.instagram.com/tiagobjjdepaula",
  "phone": "+41 78 950 39 99",
  "email": "contact@tiagodepaulabjj.com",
  "hero": {
    "eyebrow": "BJJ · MMA · COMMUNITY",
    "title": "Stronger on the mat.",
    "title_accent": "Better beyond it.",
    "intro": "Brazilian Jiu-Jitsu for adults, kids and women — taught with ambition, care and Brazilian energy in Zurich and Thalwil.",
    "image": "/images/hero.jpg",
    "image_alt": "Brazilian Jiu-Jitsu training at Tiago de Paula BJJ"
  },
  "intro": {
    "eyebrow": "WELCOME TO THE TEAM",
    "title": "Serious training. Familiar atmosphere.",
    "body": "Founded in Zurich in 2017, Tiago de Paula BJJ brings together beginners, competitors, children and families. Every class is built to help you move better, think calmly under pressure and grow with a team that supports you.",
    "quote": "You do not need to be fit to start. You start — and we build from there."
  },
  "stats": [
    {
      "value": "2",
      "label": "Dojos"
    },
    {
      "value": "45+",
      "label": "Classes a week"
    },
    {
      "value": "300+",
      "label": "Members"
    },
    {
      "value": "2017",
      "label": "Founded in Zurich"
    }
  ],
  "programs": [
    {
      "title": "Adults BJJ",
      "tag": "GI · NO-GI",
      "description": "Structured classes for first-timers through advanced practitioners, with clear technical progressions and plenty of live training.",
      "image": "/images/adults-bjj-team.svg",
      "audience": "adults"
    },
    {
      "title": "Kids & Juniors",
      "tag": "AGES 3–13+",
      "description": "Age-specific groups that build confidence, coordination, discipline and real friendships in a safe, playful setting.",
      "image": "/images/kids.jpg",
      "audience": "kids"
    },
    {
      "title": "Women Only",
      "tag": "BEGINNER FRIENDLY",
      "description": "A focused women-only environment to learn practical BJJ, develop confidence and train at your own pace.",
      "image": "/images/hero.jpg",
      "audience": "women"
    },
    {
      "title": "MMA & Competition",
      "tag": "LEVEL UP",
      "description": "Dedicated sessions for athletes who want sharper wrestling, striking, No-Gi and tournament preparation.",
      "image": "/images/mma.jpeg",
      "audience": "mma"
    }
  ],
  "dojos": [
    {
      "id": "zurich",
      "city": "Zürich",
      "name": "Zurich Dojo",
      "address": "Forchstrasse 225, 8032 Zürich",
      "description": "Our original dojo: more than 25 weekly classes, a multicultural team and programs from first steps to competition training.",
      "detail": "Gi · No-Gi · MMA · Kids · Women",
      "image": "/images/zurich-dojo-team.svg",
      "map_url": "https://www.google.com/maps/search/?api=1&query=Forchstrasse+225+8032+Zurich",
      "map_embed_url": "https://www.google.com/maps?q=Forchstrasse+225,+8032+Zurich&output=embed"
    },
    {
      "id": "silver",
      "city": "Thalwil",
      "name": "Silver Coast Dojo",
      "address": "Ludretikonerstrasse 10, 8800 Thalwil",
      "description": "A welcoming, family-friendly space on the Silver Coast with focused classes for children, adults and women.",
      "detail": "Gi · Kids · Women · Adults",
      "image": "/images/thalwil-dojo-group-2026.webp",
      "partner_logo": "/images/partners/crossroots-mma.png",
      "partner_logo_alt": "Crossroots MMA",
      "partner_name": "Cross Roots",
      "map_url": "https://www.google.com/maps/search/?api=1&query=Ludretikonerstrasse+10+8800+Thalwil",
      "map_embed_url": "https://www.google.com/maps?q=Ludretikonerstrasse+10,+8800+Thalwil&output=embed"
    }
  ],
  "coaches_intro": {
    "eyebrow": "MEET THE TEAM",
    "title": "Coaches who help you grow.",
    "intro": "Experienced martial artists, attentive teachers and one shared standard on every mat."
  },
  "coaches": [
    {
      "name": "Tiago De Paula",
      "belt": "Black Belt",
      "roles": "Founder · Head Coach",
      "bio": "Tiago earned his Black Belt under Carlson Gracie Zurich in 2022. Since beginning his BJJ journey in 2013, he has grown into a dedicated professor for kids and adults. His outgoing personality, commitment to continuous improvement and ability to motivate others make him an inspiring leader within the community. Tiago encourages every student to keep showing up and pursue growth both on and off the mats.",
      "languages": "ENG · POR · ESP · GER",
      "image": "/images/coaches/tiago-de-paula.webp",
      "image_position": "center 30%",
      "featured": true
    },
    {
      "name": "Luiz Finocchio",
      "belt": "Black Belt",
      "roles": "Head Coach · BJJ · MMA Coach",
      "bio": "Luiz is a BJJ Black Belt, professional competitor, grappling coach and former undefeated professional MMA fighter with a 3–0 record. Known for his technical precision and detailed instruction, he has competed at events including Polaris, the BJJ Grand Prix and IBJJF tournaments, while teaching seminars internationally. At Tiago de Paula BJJ, Luiz brings elite-level experience to both BJJ and MMA classes.",
      "languages": "ENG · POR",
      "image": "/images/coaches/luiz-finocchio.webp",
      "image_position": "center 22%",
      "featured": false
    },
    {
      "name": "Pedro Ledermann",
      "belt": "Black Belt",
      "roles": "BJJ · Adults & Kids Coach",
      "bio": "Pedro is a Black Belt under Marko Leisten and has trained Brazilian Jiu-Jitsu since 2012. He became a full-time instructor in 2021, beginning his teaching career at Tiago de Paula BJJ. Patient and comfortable with a little chaos, he is a natural kids coach—ask him about the ‘Takedown Spiel’. In adult classes, Pedro focuses on movement and defence: ‘It’s hard to submit a moving target.’",
      "languages": "GER · POR · ENG",
      "image": "/images/coaches/pedro-ledermann.webp",
      "image_position": "center 28%",
      "featured": false
    },
    {
      "name": "Hian Finocchio",
      "belt": "Brown Belt",
      "roles": "BJJ · Adults & Kids Coach",
      "bio": "Hian is a dedicated Brazilian Jiu-Jitsu Brown Belt under Luiz Finocchio with a strong passion for developing young talent. Specialising in kids coaching, he has helped produce numerous successful young competitors while instilling discipline, sound technique and a confident competitive mindset in the next generation of BJJ athletes.",
      "languages": "ENG · POR",
      "image": "/images/coaches/hian-finocchio.webp",
      "image_position": "center 25%",
      "featured": false
    }
  ],
  "first_visit": {
    "eyebrow": "YOUR FIRST CLASS",
    "title": "Start without pressure.",
    "intro": "No experience and no special fitness level are required. We will help you choose the right class and make sure you know what to expect.",
    "steps": [
      {
        "number": "01",
        "title": "Choose your dojo",
        "text": "Select Zurich or Thalwil and tell us which program interests you."
      },
      {
        "number": "02",
        "title": "Bring simple sportswear",
        "text": "For your first class, comfortable sportswear and a water bottle are enough. We explain everything else."
      },
      {
        "number": "03",
        "title": "Meet the team",
        "text": "Arrive a few minutes early. A coach welcomes you and guides you through the class."
      }
    ]
  },
  "contact": {
    "eyebrow": "YOUR FIRST CLASS",
    "title": "Come as you are.",
    "body": "Tell us which dojo and program interests you. We will help you choose the right class and explain what to bring.",
    "button": "Request a trial class"
  }
}
